//////////////////////////////

module.exports = function( type ) {

    var schema = {

        automation_name: {
            type: type.STRING(64),
            allowNull: false,
        },
        label: {
            type: type.STRING(64),
            allowNull: true,
        },
        customer_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'customers',
                key         : 'id',
                constraints : true,
                store_name  : 'customer',
            }
        },
        config: {
            type: type.JSONB,
            allowNull: false,
            defaultValue: {},
        },
        created: {
            type: type.DATE,
            allowNull: false,
            defaultValue : type.NOW,
        },
        enabled: {
            type: type.BOOLEAN,
            allowNull: false,
            defaultValue : true,
        },
        deleted: {
            type: type.BOOLEAN,
            defaultValue : false,
        },
        id: {
            type: type.INTEGER,
            primaryKey: true,
            autoIncrement: true
        },
    };

    return schema;
}

